import type { TextareaHTMLAttributes } from 'react';
import { cn } from '../../../lib/cn';
import { CONTROL_BASE } from './controlStyles';

export function Textarea({ className, rows = 3, ...rest }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea rows={rows} className={cn(CONTROL_BASE, 'min-h-[80px] resize-y py-2 text-[13px]', className)} {...rest} />;
}
